/* CUSTOM PATCH: Aktualisiert CustomStockAvailability und Button-Sync bei Variantenwechsel.
   Verwendet das vom Theme bereits fuer die ausgewaehlte Variante gerenderte HTML. */
(function () {
  if (window.__customStockAvailabilityPatched) return;
  window.__customStockAvailabilityPatched = true;

  function updateCustomElements(event) {
    var data = event && event.data;
    if (!data || !data.parsedHTML || !data.sectionId || !data.productId) return;

    var sectionId = data.sectionId;
    var productId = data.productId;
    var doc = data.parsedHTML;
    var variantData = getVariantData(doc, sectionId, productId, data.variant && data.variant.id);

    updateVariantDetails(data.variant && data.variant.id);

    // Verfuegbarkeitsblock aus dem bereits gerenderten Varianten-HTML uebernehmen.
    var customId = 'CustomStockAvailability-' + sectionId + '-' + productId;
    var customSource = doc.getElementById(customId);
    var customDest = document.getElementById(customId);

    if (customSource && customDest) {
      customDest.innerHTML = customSource.innerHTML;
      customDest.toggleAttribute('hidden', customSource.hasAttribute('hidden'));

      // Die alte NGB-Logik arbeitet mit einer Map aller Varianten und der echten Variant-ID.
      if (variantData && variantData.preOrder === 'true') {
        var alert = customDest.querySelector('.alert');
        var label = customDest.querySelector('.alert > span');
        var template = customDest.getAttribute('data-pre-order-text') || '';

        customDest.removeAttribute('hidden');
        if (alert) {
          alert.classList.remove('alert--error');
          alert.classList.add('alert--success');
          alert.setAttribute('data-stock-state', 'pre-order');
        }
        if (label) label.textContent = template.replace('[lieferzeit]', variantData.deliveryLabel || '');
      }
    }

    // Haupt- und Sticky-Button muessen denselben Vorbestellstatus erhalten.
    var formId = 'ProductForm-' + sectionId + '-' + productId;
    var selector = 'button[name="add"][form="' + formId + '"]';
    var sourceButtons = doc.querySelectorAll(selector);
    var destButtons = document.querySelectorAll(selector);

    destButtons.forEach(function (dest, index) {
      var source = sourceButtons[index];
      if (!source) return;

      var isPreOrder = variantData
        ? variantData.preOrder === 'true'
        : source.hasAttribute('data-pre-order');

      dest.toggleAttribute('data-pre-order', isPreOrder);
      dest.setAttribute('aria-label', source.getAttribute('aria-label') || '');

      var destLabel = dest.querySelector('.btn-text > span') || dest.querySelector('.btn-text');
      var sourceLabel = source.querySelector('.btn-text > span') || source.querySelector('.btn-text');
      if (destLabel && sourceLabel) {
        destLabel.textContent = isPreOrder
          ? ((customDest && customDest.getAttribute('data-pre-order-button-text')) || theme.variantStrings.preOrder)
          : sourceLabel.textContent;
      }
    });
  }

  /* CUSTOM 2026-07-30: EAN und Gewicht im Produktdetails-Block aktualisieren.
     Dieser Block liegt in der Section "product-details" und wird beim Variantenwechsel nicht
     neu gerendert. Die Werte aller Varianten stehen als JSON im Markup; hier wird nur der
     Text getauscht — ohne zusaetzlichen Request. */
  function updateVariantDetails(variantId) {
    if (!variantId) return;

    var quelle = document.querySelector('[data-variant-details]');
    if (!quelle) return;

    var alle;
    try {
      alle = JSON.parse(quelle.textContent);
    } catch (e) {
      return;
    }

    var werte = alle[String(variantId)];
    if (!werte) return;

    var eanZeile = document.querySelector('[data-ean-row]');
    var eanWert = document.querySelector('[data-ean-value]');
    if (eanZeile && eanWert) {
      if (werte.ean) {
        eanWert.textContent = werte.ean;
        eanZeile.hidden = false;
      } else {
        /* Hat die Variante keine EAN, wird die Zeile ausgeblendet statt eine falsche stehen zu lassen. */
        eanZeile.hidden = true;
      }
    }

    var gewichtZeile = document.querySelector('[data-weight-row]');
    var gewichtWert = document.querySelector('[data-weight-value]');
    if (gewichtZeile && gewichtWert) {
      var gramm = Number(werte.grams) || 0;
      if (gramm > 0) {
        /* Gleiche Formatierung wie in custom-product-details-row.liquid: ab 1000 g in kg. */
        gewichtWert.textContent =
          gramm >= 1000 ? String(Math.round((gramm / 1000) * 100) / 100) + ' kg' : String(Math.round(gramm)) + ' g';
        gewichtZeile.hidden = false;
      } else {
        gewichtZeile.hidden = true;
      }
    }
  }

  function getVariantData(doc, sectionId, productId, variantId) {
    if (!variantId) return null;

    var id = 'NgbPreOrderVariants-' + sectionId + '-' + productId;
    var script = doc.getElementById(id) || document.getElementById(id);
    if (!script) return null;

    try {
      var variants = JSON.parse(script.textContent);
      return variants[String(variantId)] || null;
    } catch (error) {
      console.error('[NGB Pre-Order] Variantendaten konnten nicht gelesen werden.', error);
      return null;
    }
  }

  function init() {
    // Listen to variant changes via pubsub
    if (window.theme && window.theme.pubsub) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, updateCustomElements);
    } else {
      setTimeout(init, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
